import { api } from './index';

export const supportChatMessagesApi = {
  create(data: Partial<SupportChatMessage>) {
    const path = '/api/internal/support_chat_messages';

    return api({
      method: 'post',
      url: path,
      data,
    });
  },
  adminCreate(data: Partial<SupportChatMessage>) {
    const path = '/api/internal/support_chat_messages/admin_create';

    return api({
      method: 'post',
      url: path,
      data,
    });
  },
};
